<template>
  <div class="dashboard">
    <!-- <Modal
      title="｢ネイティブの口」の使い方"
      ref="modal"
      headerIcon="question-circle"
      neverShowContent="dashboardFist"
    >
      <ModalInnerFistDashboard />
    </Modal>-->

    <!-- <Modal ref="micGuide" title="マイクについての注意事項" titleIcon="el-icon-mic">
      <div class="mic-guide">
        <div class="volume">
          <h3>マイクの位置について</h3>
          <img src="@/assets/guides/mic.png" />
          <p>マイクに出来るだけ口を近づけて使用してください。</p>
        </div>
        <div class="accept-mic">
          <h3>マイク入力の許可について</h3>
          <img src="@/assets/headphones.svg" />
          <p>音声認識を開始した初回の表示される「～～～」は必ず許可してください。</p>
        </div>
      </div>
    </Modal> -->

    <ExcerciseModal ref="exModal" />

    <Modal
      ref="unlockPurchaseModal"
      title="「全レッスンのロックを解除」のご購入"
      :agreeButton="false"
      :visibleNeverShowCheckbox="false"
    >
      <div
        style="display:flex; flex-direction: column; align-items:center; justify-content: center"
      >
        <img src="@/assets/guides/unlock-demo.jpg" width="500" />
        <p
          style="font-weight:bold; margin: 0 0 5px 0; font-size: 1.2rem"
        >¥980（買い切り）で全てのレッスンのロックを解除することができます。</p>
        <Source />
        <p class="change-credit-guide">使用するクレジットカードを変更する場合は、「各種設定」より設定してください</p>
        <button class="button" @click="buyUnlock">「全レッスンのロックを解除」を購入する</button>
      </div>
    </Modal>
    <!-- Modal for CMU Dictionary Download -->
    <div class="container">
      <!-- TEST -->
      <div class="header-container">
        <div class="header">
          <div>
            <img class="icon" src="@/assets/exam.svg" />
            <h1 class="text">発音テスト</h1>
          </div>
          <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
        </div>
      </div>
      <!-- 
      <div class="test-ui">
        <TestResultsLeft />

        <div class="test-ui-inner-right">
          <div class="test-score">
            <button
              class="button"
              style="display: flex; flex-direction: row; align-items:center;padding: 10px 30px;"
              @click="$router.push('test')"
            >
              <img
                src="@/assets/nklogo.png"
                height="22"
                style="margin-right: 5px"
              />
              テストを受験する
            </button>
          </div>

          <router-link :to="{ name: 'Test' }"></router-link>
        </div>
      </div>-->

      <Statistics />
      <div style="width: 100%">
        <button
          class="button"
          style="margin: 30px auto;display: flex; flex-direction: row; align-items:center;padding: 13px 40px; font-size: 1.2rem"
          @click="$router.push('test')"
        >
          <img src="@/assets/nklogo.png" height="30" style="margin-right: 5px" />
          テストを受験する
        </button>
      </div>

      <div>
        <div class="header-container">
          <div class="header">
            <div>
              <img class="icon" src="@/assets/blackboard.svg" />
              <h1 class="text">基本の発音レッスン</h1>
            </div>
            <div class="header-description">英語の発音方法を、発音記号から、独自のメソッドと3D映像で解説しています。</div>
          </div>

          <div class="unlock-all" @click="unlockPurchase">
            <div>
              {{
              $store.state.userData.unlock
              ? "全レッスン解除済み"
              : "全レッスンのロックを解除"
              }}
            </div>
            <i class="el-icon-unlock" v-if="!$store.state.userData.unlock" />
          </div>

          <div class="training-acc">
            <div class="title">トレーニング累積スコア</div>
            <div class="score">
              <AnimatedNumber :value="Math.floor($store.state.userData.totalScore)" />
            </div>
          </div>
        </div>

        <div class="phoneme-type-container">
          <div
            class="phoneme-type-border"
            style="overflow: hidden;border: 1px solid #555; display:inline-block;"
          >
            <div
              class="phoneme-type"
              :class="{ active: $store.state.selectedCategory === 'consonant' }"
              @click="changePhonemeType('consonant')"
            >子音編</div>
            <div
              class="phoneme-type"
              :class="{ active: $store.state.selectedCategory === 'vowel' }"
              @click="changePhonemeType('vowel')"
            >母音編</div>
            <div
              class="phoneme-type"
              :class="{ active: $store.state.selectedCategory === 'exercise' }"
              @click="changePhonemeType('exercise')"
            >エクササイズ一覧</div>
            <i class="el-icon-search"></i>
            <input type="text" placeholder="単語から検索..." v-model="lessonSearch" />
          </div>
        </div>

        <div style="text-align: center">
          <div class="lesson-search" v-show="searchResult">
            <div class="target-label">検索対象</div>
            {{ searchResult }}
          </div>
        </div>

        <div class="lesson-item-list">
          <div v-for="(lesson, index) in $store.state.selectedLessons" :key="index">
            <LessonBlock
              @click="goToLesson(lesson)"
              :key="index"
              :lesson="lesson"
              :scoreNeedTotalUnlock="lesson.neededScore"
              :targetBlank="false"
              :lock="
                lesson.neededScore > totalScore && !$store.state.userData.unlock
              "
              :first="index === 0"
              :scoreNeedToUnlock="lesson.neededScore - totalScore"
              :recentlyUnlocked="
                totalScore - lesson.neededScore < 500 &&
                  totalScore - lesson.neededScore > 0
              "
              :completed="
                ($store.state.userData.completedByPhoneme[lesson.titlePhoneme] /
                  totalProblems[lesson.titlePhoneme]) *
                  100
              "
            />
          </div>
        </div>
        <div class="exercises-container" v-if="$store.state.selectedCategory === 'exercise'">
          <div class="exercises">
            <div
              class="exercise"
              v-for="(video, index) in videos"
              :key="index"
              @click="showExerciseModal(video)"
            >
              <div
                class="image"
                :style="
                  `background-image: url('exercise_images/${video.id}.jpg')`
                "
              ></div>
              <div class="details">
                <div class="upper">
                  <div class="title">{{ video.name }}</div>
                  <div
                    class="level"
                    :style="`background-color: ${levelColors[video.level]}`"
                  >{{ levels[video.level] }}</div>
                </div>
                <div class="description">{{ video.description }}</div>

                <ul>
                  <li v-for="(p, index) in video.pron" :key="p">
                    <router-link
                      v-if="index < 14"
                      class="phoneme"
                      :to="{ path: 'lesson', query: { category: p } }"
                      :style="
                        p === '(h)w'
                          ? `font-size: 0.78rem`
                          : `font-size: 1.1rem`
                      "
                    >{{ p }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="powered-by">
        Powered by
        <a href="https://discoveringsounds.com/" target="_blank">
          <img src="@/assets/ds.jpg" />
        </a>
      </div>

      <div v-if="false">
        <div class="header">
          <img class="icon" src="@/assets/puzzle.svg" />
          <h1 class="text">分野別発音トレーニング</h1>
          <div class="header-description">ご契約いただいている様々なカスタムトレーニングを行うことができます。</div>
        </div>
        <p
          v-show="customTrainings.length === 0"
          style="text-align:center; color:#aaa"
        >現在ご利用頂けるトレーニングがありません。</p>
        <div class="custom-training-container">
          <CustomTrainingBlock
            v-for="(training, index) in customTrainings"
            :key="index"
            :title="training.title"
            :detail="training.detail"
            :bgUrl="training.bgUrl"
            class="custom-training-item"
          />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/functions";
import pronDict from "@/utils/PronDictionary";
// import resultRepo from "@/utils/TestResultRepository";
// import problemResultRepo from "@/utils/ProblemResultRepository";
import { CLEAR_SCORE } from "@/constants";

import { db } from "@/plugins/firebase";
import { Loading } from "element-ui";

const lessons = require("@/resources/lessons.json");
const videos = require("@/resources/videos.json");
const _ = require("lodash");

export default {
  name: "Dashboard",
  components: {
    LessonBlock: require("./LessonBlock").default,
    CustomTrainingBlock: require("./CustomTrainingBlock").default,
    MicGuide: require("./MicGuide").default,
    Footer: require("@/components/Footer").default,
    AnimatedNumber: require("@/components/AnimatedNumber").default,
    ProgressCircle: require("@/components/ProgressCircle").default,
    Modal: require("@/components/Modal").default,
    ExcerciseModal: require("./ExcerciseModal").default,
    CreditCard: require("@/components/CreditCard").default,
    Source: require("@/components/Source").default,
    ModalInnerFistDashboard: require("./ModalInnerFistDashboard").default,
    Statistics: require("./Statistics").default
  },
  computed: {
    totalScore() {
      return this.$store.state.userData.totalScore;
    },
    completedProblemsPercentage() {
      const userCompleted = this.$store.state.userData.completedByPhoneme;
      if (userCompleted && this.totalProblems) {
        return Math.ceil(
          (_.sum(Object.values(userCompleted)) /
            _.sum(Object.values(this.totalProblems))) *
            100
        );
      } else {
        return 0;
      }
    }
  },
  watch: {
    lessonSearch(text) {
      let self = this;
      pronDict.getIpaFromSingleText(text).then(result => {
        // find IPA from text
        const searched = result
          .map(word => {
            if (word) {
              return word
                .map(ph => {
                  return ph.withStress;
                })
                .join("");
            }
          })
          .join(" ");
        this.searchResult = searched;
        // find used phonemes
        let searchPhonemes = [];
        result.forEach(word => {
          if (word) {
            word.forEach(ph => {
              if (ph.withStress === "ʌ́" || ph.withStress === "ʌ̀") {
                searchPhonemes.push("ʌ");
              } else {
                searchPhonemes.push(ph.withoutStress);
              }
            });
          }
        });

        if (searchPhonemes.length > 0) {
          this.searchPhonemes = searchPhonemes;

          const lessons = searchPhonemes.map(ph => {
            return this.lessons.filter(lesson => {
              return lesson.targetPhoneme === ph;
            })[0];
          });

          this.$store.commit("setLessonType", searchPhonemes);
        }
      });
    }
  },
  data() {
    return {
      levels: ["基礎編", "発展編", "応用編"],
      levelColors: ["#888", "#f99", "#f66"],
      videos: videos
        .filter(video => video.type === "exercise")
        .sort((a, b) => a.level - b.level),

      maxScore: 0,
      maxDate: new Date(),

      showTabs: {
        consonants: false,
        vowels: false
      },
      lessons: [],
      allLessons: [],
      searchResult: null,
      lessonSearch: "",
      highestScore: 5757,
      phonemeType: "consonant",
      searchPhonemes: [],
      problemResults: {},
      myCompletedProblems: {},
      totalProblems: {},
      password: [],
      customTrainings: [
        {
          title: "大学入試対策トレーニング",
          detail:
            "大学入試問題としてよく出題されるアクセント問題などをトレーニングすることができます。",
          bgUrl:
            "https://cdn.britannica.com/52/124752-050-C6AA6622/Yasuda-Auditorium-University-of-Tokyo.jpg"
        },
        {
          title: "TOEIC(R)対策トレーニング",
          detail:
            "TOEIC(R)試験によく出題されるアクセント問題などをトレーニングすることができます。",
          bgUrl:
            "https://blog.thelinguist.com/wp-content/uploads/2016/10/Preparing-for-the-TOEIC-Test.png"
        },
        {
          title: "エアライン業界向けトレーニング",
          detail:
            "CAのアナウンスや乗客との接客で頻繁に用いられるフレーズなどをトレーニングできます。",
          bgUrl:
            "https://www.gaigo.ac.jp/wordpress/wp-content/themes/gaigo/img/course/airline/course_main.jpg"
        },
        {
          title: "ドラッグストアでの接客トレーニング(1)",
          detail:
            "CAのアナウンスや乗客との接客で頻繁に用いられるフレーズなどをトレーニングできます。",
          bgUrl:
            "https://pcareer-kuchikomi-contents.s3.amazonaws.com/uploads/production/common_file/file_name/0000000209.jpg"
        }
      ]
    };
  },

  async mounted() {

    // setTimeout(() => {
      // this.$refs.micGuide.showModal();
      // if (!this.$store.state.showedMicGuideModal)
        // this.$store.commit("showMicGuideModal");
    // }, 1000);
    await this.$store.dispatch("loadUserData", null, { root: true });
    const status = this.$store.state.userData.subscription.status;
    const purchased = status === "trialing" || status === "active";

    if (!purchased) {
      this.$router.replace("/subscribe");
          document.title = `ネイティブの口 | 課金登録ページ`;
    } else if (status === "past_due" || status === "canceled") {
      this.$router.replace("/subscribe");
          document.title = `ネイティブの口 | 課金登録ページ`;

    }

    document.title = `ネイティブの口 | ダッシュボード`;
    let self = this;

    this.$store.dispatch("loadAllLessons");
    this.setScores();
  },
  methods: {
    showExerciseModal(video) {
      this.$refs.exModal.showModal(video);
    },
    buyUnlock() {
      const unlockLoading = Loading.service({
        lock: true,
        text:
          "現在クレジットカードで決済処理を行っています、ウィンドウを閉じないようにお願い致します",
        background: "rgba(255, 255, 255, 0.9)",
        customClass: "loading"
      });
      const purchaseUnlock = firebase
        .functions()
        .httpsCallable("purchaseUnlock");
      purchaseUnlock()
        .then(result => {
          unlockLoading.close();
          this.$refs.unlockPurchaseModal.closeModal();
          this.$notify({
            type: "success",
            title: "成功",
            message:
              "「全レッスン開放」の購入が成功しました。ご購入頂き誠に有難うございました。"
          });
        })
        .catch(err => {
          this.$notify({
            type: "error",
            title: "失敗",
            message: "「全レッスン開放」の購入に失敗しました。" + err
          });
        });
    },
    unlockPurchase() {
      if (!this.$store.state.userData.unlock) {
        this.$refs.unlockPurchaseModal.showModal();
      }
    },
    setScores() {
      let self = this;
      // db.collection("users")
      //   .doc(this.$store.state.auth.user.uid)
      //   .get()
      //   .then(snapshot => {
      //     self.myCompletedProblems = snapshot.data().completedByPhoneme;
      //   });
      db.collection("workbooksInfo")
        .doc("workbooksLength")
        .get()
        .then(snapshot => {
          self.totalProblems = snapshot.data().total;
        });
    },
    changePhonemeType(category) {
      this.$store.commit("setLessonType", category);
    },
    setLessonsAfterSearchLesson() {},
    spliceAndPushLessons(prev, next) {},

    goToLesson(lesson) {
      this.$router.push({
        path: "lesson",
        query: { category: lesson.titlePhoneme }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  /* padding-bottom: 500px; */
}

.header-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 30px 50px 10px 50px;
  .header {
    display: flex;
    flex-direction: column;
    flex: 0.8;
    div {
      display: flex;
      flex-direction: row;
    }
    h1 {
      font-size: 1.9rem;
      margin: 0;
    }
    .header-description {
      font-size: 1rem;
      font-weight: bold;
    }

    img {
      width: 38px;
      margin-right: 15px;
    }
  }
  .training-acc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #eee;
    width: 200px;
    height: 90px;
    border-radius: 5px;
    position: relative;
    text-align: center;
    .title {
      border-bottom: 1px solid #eee;
      display: block;
      padding: 0px 0 5px 0;
      width: 100%;
      font-size: 0.9rem;
    }
    .score {
      font-size: 2rem;
      font-weight: 900;
    }
  }
  .unlock-all {
    background-color: #f88;
    color: white;
    margin: 20px 0;
    font-weight: bold;
    font-size: 1rem;
    border-radius: 100px;
    text-align: center;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    box-shadow: 3px 3px 14px 0px #f88;
    transition: all 0.3s ease;
    cursor: pointer;
    i {
      width: 20px;
      padding-left: 10px;
      margin: 0;
      font-size: 1.2rem;
    }
    &:hover {
      color: #555;
      background-color: #fff;
    }
  }

  @include mq(sm) {
    flex-direction: column;
    .unlock-all {
      margin: 20px 0 10px 0;
    }
  }
  @include mq(md) {
    flex-direction: row;
    .unlock-all {
      margin: 0;
    }
  }
  @include mq(lg) {
    flex-direction: row;
    .unlock-all {
      margin: 0;
    }
  }
  @include mq(xl) {
    flex-direction: row;
    .unlock-all {
      margin: 0;
    }
  }
}

.lesson-item-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0;
  justify-content: center;
  align-items: center;
}

.phoneme-type {
  cursor: pointer;
  text-align: center;
  z-index: 300;
  font-size: 1rem;
  display: inline-block;
  margin: 0 auto;
  padding: 5px 20px;
  background-color: white;
  color: #555;
  &:hover {
    background-color: #777;
    color: white;
  }
}

.active {
  background-color: #555;
  color: white;
}

.phoneme-type-container {
  margin: 15px 0;
  font-weight: bold;
  text-align: center;
  position: relative;
  i {
    color: #555;
    transform: translateX(25px) translateY(-1px);
  }
  input[type="text"] {
    margin-left: 0px;
    padding-left: 35px;
    margin-right: 14px;
    border-radius: 3px;
    width: 150px;
    background-color: #f7f7f7;
    border: none;
    transition: all 0.3s ease;
    user-select: none;
    outline: none;
    display: inline-block;
    font-size: 1.1rem;
    color: #555 !important;
    font-family: "Noto Sans Japanese", Arial, sans-serif;

    &::placeholder {
      padding-left: 5px;
      /* font-weight: bold; */
      color: #888;
    }
    &:placeholder-shown {
    }
    &:focus {
      width: 250px;
      background-color: #eaeaea;
      @at-root .phoneme-type-container {
        i {
          /* color: #f88 !important;   */
        }
      }
    }
  }
}

.lesson-search {
  text-align: center;
  transition: all 1s ease;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 15px 0;
  background-color: #eee;
  padding: 5px 10px;
  display: inline-block;

  .target-label {
    font-size: 0.8rem;
  }
}

.custom-training-container {
  margin: 0 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .custom-training-item {
    margin-left: 10px;
    margin-top: 10px;
    padding: 5px;
  }
}

.powered-by {
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-weight: 900;
  color: #231815;
  margin-top: 30px;
  user-select: none;

  img {
    width: 260px;
    margin: 0 50px 0 10px;
    padding-top: 5px;
    opacity: 1;
    transition: all 0.2s ease;
    &:hover {
      transform: scale(1.03);
      opacity: 0.8;
    }
  }
}

// Exercise List

.exercises-container {
  /* margin: 0 50px; */
}

.exercises {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: left;
}

h3 {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 1.6rem;
  font-weight: 900;
}

.exercise {
  .image {
    min-width: 180px;
    height: 220px;
    background-size: cover;
    background-position: center;
    transition: background-size 0.3s ease;
  }

  .upper {
    display: flex;
    border-bottom: 1px solid #ddd;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 3px;
  }

  .level {
    font-size: 0.78rem;
    font-weight: normal;
    color: white;
    border-radius: 13px;
    display: block;
    width: 50px;
    padding: 2px 3px;
    margin-bottom: 2px;
    text-align: center;
    align-self: flex-end;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title {
    font-size: 1.2rem;
    /* padding-bottom: 3px; */
  }

  .details {
    margin: 13px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .description {
      font-size: 0.85rem;
      font-weight: normal;
    }
  }

  &:hover {
    .upper {
      border-bottom: 1px solid #f88;
    }
  }

  cursor: pointer;
  /* padding: 10px 30px; */
  width: 480px;
  height: 220px;
  font-size: 1.2rem;
  border-radius: 4px;
  font-weight: bold;
  margin: 10px 5px;
  border: 1px solid #eee;
  display: flex;
  flex-direction: row;
  &:hover {
    background-color: #fafafa;
  }
}

.phoneme {
  height: 27px !important;
  width: 27px !important;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 50%; /* may require vendor prefixes */
  background: #eee;
  color: #555 !important;
  transition: all 0.2s ease;
  &:hover {
    background-color: $main-color;
    color: white !important;
    transform: scale(1.1);
  }
}

ul {
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

h3 {
  margin: 0;
  margin-bottom: 10px;
  font-size: 1.2rem;
}
.mic-guide {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  .volume,
  .accept-mic {
    width: 320px;
    display: block;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    p {
      text-align: left;
      margin: 0;
    }
    img {
      width: 140px;
      margin: 15px auto;
    }
  }
}
.change-credit-guide {
  font-size: 0.8rem;
  width: 100%;
  text-align: center;
  margin: 5px 0;
}
</style>
